module.exports = __webpack_public_path__ + "static/media/setupfoldericon.b8adc7b8.svg";